import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "dialog",
  class: "create-registration-token rounded-lg p-6 max-w-md w-full shadow-lg"
}
const _hoisted_2 = { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "break-all" }
const _hoisted_5 = { class: "flex justify-end space-x-3 mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")

  return (_openBlock(), _createElementBlock("dialog", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_2, [
        _withDirectives(_createElementVNode("span", null, "New User Registration URL", 512 /* NEED_PATCH */), [
          [_vShow, $props.user_id === null]
        ]),
        _withDirectives(_createElementVNode("span", null, "Reset Password URL", 512 /* NEED_PATCH */), [
          [_vShow, $props.user_id !== null]
        ])
      ]),
      _withDirectives(_createElementVNode("span", null, _cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "fa-solid fa-spinner animate-spin" }, null, -1 /* CACHED */),
        _createTextVNode(" Generating URL...")
      ]), 512 /* NEED_PATCH */), [
        [_vShow, $setup.dat_loading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.dat_registration_url), 1 /* TEXT */),
        _createElementVNode("button", {
          onClick: $setup.copyToClipboard,
          class: "text-gray-500 hover:text-gray-700"
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fa-solid fa-copy" }, null, -1 /* CACHED */)
        ]))
      ], 512 /* NEED_PATCH */), [
        [_vShow, !$setup.dat_loading]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_basic_button, {
        error: "",
        disabled: false,
        size: 'small',
        onClick: _cache[0] || (_cache[0] = $event => ($setup.done()))
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Done ")
        ])),
        _: 1 /* STABLE */,
        __: [3]
      })
    ])
  ], 512 /* NEED_PATCH */))
}